export default __webpack_public_path__ + "static/media/etihadlogo.f583d0f1.svg";